module.exports = __webpack_public_path__ + "media/images/svg-icon/logout-d2dd9eb6142c29248a758328ac1ce0b9.svg";